import { render, staticRenderFns } from "./CbsBudreqScenario.vue?vue&type=template&id=2e1b3a96&scoped=true"
import script from "./CbsBudreqScenario.vue?vue&type=script&lang=js"
export * from "./CbsBudreqScenario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1b3a96",
  null
  
)

export default component.exports